import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import roundReducer from './reducers/roundReducer';
import botManagerReducer from './reducers/botManagerReducer';
import sessionReducer from './reducers/sessionReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  round: roundReducer,
  botManager: botManagerReducer,
  session: sessionReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
